import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ArquivoModel } from '@shared/models/backend'
import { take } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class FileUploaderService {
  constructor(private http: HttpClient) {}
  upload(file: File) {
    const formData = new FormData()
    formData.append('arquivo', file)

    return this.http.post<ArquivoModel>('api/arquivos', formData).pipe(take(1))
  }
}
